import { createSelector } from "reselect";
import { getChapterEntity } from "selectors/chapter/makeGetChapterEntity";

const getStoryVideo = (state) => state.story.video;
const getSlideshowSlides = (state) => state.story.entities.slide;

export default createSelector(
  getChapterEntity,
  getSlideshowSlides,
  getStoryVideo,
  (chapterEntity, slideshowSlides, storyVideo) => {
    const firstSlideVideo =
      chapterEntity.slides &&
      chapterEntity.slides.length > 0 &&
      slideshowSlides[chapterEntity.slides[0]].video;
    const pathfinderIntroVideo =
      chapterEntity.introductionVideo && chapterEntity.introductionVideo.video;
    const pathfinderLoopVideo =
      chapterEntity.loopVideo && chapterEntity.loopVideo.video;
    const chapterVideo = chapterEntity.video;
    const idleVideo = chapterEntity.idleVideo;

    const videoId =
      firstSlideVideo ||
      pathfinderIntroVideo ||
      pathfinderLoopVideo ||
      idleVideo ||
      chapterVideo ||
      storyVideo;

    return videoId;
  },
);
